"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../core/model/DomainObject");

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * User permission. Combines a resource and action with this resource. E.g. open-release.
 * Permissions are assigned to the roles (m:n) in OAuth server.
 *
 * @author Radek Beran
 */


var Permission =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Permission, _DomainObject_1$Domai);

  function Permission(name) {
    var _this;

    _classCallCheck(this, Permission);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Permission).call(this));
    _this.name = name;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(Permission, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof Permission) {
        return this.name === other.name;
      } else {
        return false;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.name);
    }
  }]);

  return Permission;
}(DomainObject_1.DomainObject);

exports.Permission = Permission;